module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ywu4ic/images/Cover.jpg?1693228932302",
      "alt": "This image is the cover for the book Alice Never After #1, Alice Never After"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Alice Never After #1, Alice Never After\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Alice finally got her wish. Wonderland has become her new home, but with her abuser’s avatar with the uncanny grin turning the mad residents of a moonstruck world against her, she’s clawing for a little rationality amongst the chaos. As Alice’s sister Edith and her childhood friend Earl fight for a way to bring her back, Alice has to contend with whether or not her torment is due to her father, herself, or maybe a curious combination of both… Superstar writer Dan Panosian (Unkindness of Ravens, Black Tape) and artist Giorgio Spalletta (007: For King& Country) explore the morbid side of escapism in this twisted tale that blurs the line between fantasy and reality.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dan Panosian, Giorgio Spalletta\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0